// test1550
(1550 && 0);
